import script from "./FinalView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinalView.vue?vue&type=script&setup=true&lang=js"

import "./FinalView.vue?vue&type=style&index=0&id=55b625d7&lang=scss"

const __exports__ = script;

export default __exports__